var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageBubbleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62043 24.2776L0 32.089L9.47386 30.086C13.3324 31.9474 17.8248 32.5078 22.116 31.663C26.4072 30.8183 30.2051 28.626 32.8035 25.4936C35.4019 22.3612 36.6241 18.502 36.2427 14.6335C35.8613 10.765 33.9024 7.1504 30.7302 4.46183C27.5579 1.77327 23.3882 0.193661 18.9963 0.0167184C14.6044 -0.160224 10.2892 1.07754 6.85296 3.49986C3.41676 5.92218 1.09341 9.36423 0.314892 13.186C-0.463628 17.0078 0.355662 20.9493 2.62043 24.2776ZM19.8445 16.0447C19.8445 16.9774 19.0883 17.7336 18.1556 17.7336C17.2228 17.7336 16.4667 16.9774 16.4667 16.0447C16.4667 15.1119 17.2228 14.3558 18.1556 14.3558C19.0883 14.3558 19.8445 15.1119 19.8445 16.0447ZM25.7556 17.7336C26.6883 17.7336 27.4445 16.9774 27.4445 16.0447C27.4445 15.1119 26.6883 14.3558 25.7556 14.3558C24.8228 14.3558 24.0667 15.1119 24.0667 16.0447C24.0667 16.9774 24.8228 17.7336 25.7556 17.7336ZM12.2445 16.0447C12.2445 16.9774 11.4883 17.7336 10.5556 17.7336C9.62284 17.7336 8.8667 16.9774 8.8667 16.0447C8.8667 15.1119 9.62284 14.3558 10.5556 14.3558C11.4883 14.3558 12.2445 15.1119 12.2445 16.0447Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubbleIcon);
export default __webpack_public_path__ + "static/media/message-bubble-icon.153cff527ffb85e9317fa57861107093.svg";
export { ForwardRef as ReactComponent };